// src/services/auditoria.js
import api from "./config";

/**
 * 📌 OBTENER EVENTOS DE AUDITORÍA DEL MÉDICO AUTENTICADO
 * - Read-only
 * - Backend filtra por request.user
 * - Paginado desde backend
 */
export const getEventosAuditoria = async (params = {}) => {
  try {
    const response = await api.get("/auditoria/eventos/", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error obteniendo auditoría:", error);
    return null;
  }
};
